import Vue from 'vue'
import VueRouter from 'vue-router'
// eslint-disable-next-line no-unused-vars
import firebase from 'firebase/compat/app'
//import Home from '../views/Home.vue'
import  store  from '../state/store'
import firebaseServices from '../_services/firebase'
import Error404 from '../components/auth/Error404'
import HomePage from '../views/bike'
import WorldHome from '../components/worldhome';
import researchLab from '../views/researchLab';
import FormHome from '../views/formpage'
import Dashboard from '../components/Dashboard'
//import Login from '../components/auth/Login'
import SignUp from '../components/auth/SignUp'
import forgotPassword from '../components/auth/ForgotPassword'
import Awards from '../views/interactionHome';
import ResourceLibrary from '../views/resourceLibrary'
import MatchingGame from '../components/MatchingGame'
//import VueGtag from "vue-gtag";
//Vue.use(VueGtag, {
 /// config: { id: "GTM-PCNWMJK" },
//  includes: [
  //  { id: 'GTM-55S9W6G' },
//    { 
  //    id: 'UA-1234567-3',
    //  params: {
      //  send_page_view: false
     // }
  //  }
  //]
//}, router);
Vue.use(VueRouter)

const routes = [
 
    { path: '/', name:'home',component: HomePage ,       
    meta: {
      title: 'Home',
      requiresAuth: true,
      authorizedRoles: ['organizer', 'student', 'educator']
    }
  },
  
    { path: '/worlds/:worldname', name:"individualWorld" ,component: WorldHome,
    meta: {
      title: 'Worlds',
      requiresAuth: true,
      authorizedRoles: ['organizer', 'student', 'educator']
    }
  
  },
    { path: '/worlds', name:"researchLab",component: researchLab,
    meta: {
      title: 'Research Lab',
      requiresAuth: true,
      authorizedRoles: ['organizer', 'student', 'educator']
    }
  
  },


    { path: '/formssummary',name:"formhome", component: FormHome,
    meta: {
      title: 'Form Home',
      requiresAuth: true,
      authorizedRoles: ['organizer', 'student', 'educator']
    }
  
  
  },
    { path: '/awards',name:"Awards", component: Awards,
  
    meta: {
      title: 'Awards',
      requiresAuth: true,
      authorizedRoles: ['organizer', 'student', 'educator']
    }
  },

    /*{
      path: "/login",
      name: "Login",
      component: Login,
    },*/
    {
      path: "/register",
      name: "SignUp",
      component: SignUp,
      meta: {
        title: 'Auth',
        
      }
    },
    {
      path: "/login",
      name: "login",
      component: SignUp,
      meta: {
        title: 'Auth',
        
      }
    },
    {
      path: "/forgotPassword",
      name: "forgotPassword",
      component: forgotPassword,
    },
    {
      path: "/register",
      name: "SignUp",
      component: SignUp,
      meta: {
        title: 'Auth',
        
      }
    },
    {
      path: "/login",
      name: "login",
      component: SignUp,
      meta: {
        title: 'Auth',
        
      }
    },
    {
      path: "/game",
      name: "game",
      component: MatchingGame,
      meta: {
        title: 'Game',
        requiresAuth: true,
        authorizedRoles: ['organizer', 'student', 'educator']
      }
    },

    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        requiresAuth: true,
        authorizedRoles: ['organizer', 'student', 'educator']
      }
    },  {
      path: "/resourceLibrary",
      name:"resourceLibrary",
      component: ResourceLibrary,
      meta: {
        title: 'Resource Library',
        requiresAuth: true,
        authorizedRoles: ['organizer', 'student', 'educator']
      }
    },

    
    /*{
      path: "/forgot-password",
      name: "forgotPassword",
      component: ForgotPassword,
      beforeEnter(_to, _from, next) {
        const user = firebase.auth().currentUser;
        if (user) {
          next({ name: "dashboard" });
        } else {
          next();
        }
      },
    },*/

   {
     path: "/404",
     name: "404",
     component: Error404,
    },
    // otherwise redirect to home
    { path: '*', redirect: '/404' }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes:routes
})

export default router
function getUserState() {
  return new Promise((resolve/*, reject*/) => {
    console.log(store.state.user.currentUser)
    if (store.state.user.currentUser === null) {
      const unwatch = store.watch(
        () => store.state.user.currentUser,
        (value) => {
          unwatch()
          resolve(value)
        }
      )
    } else {
      resolve(store.state.user.currentUser)
    }
  })
}
function checkRole(authorizedRoles, userRole) {
  console.log(authorizedRoles)
  console.log(userRole)

  return authorizedRoles.indexOf(userRole) > -1
}
// Navigational Guards
router.beforeEach(async (to, _from, next) => {
  const { ensureAuthIsInitialized, isAuthenticated } = firebaseServices
  try {
    // Force the app to wait until Firebase has
    // finished its initialization, and handle the
    // authentication state of the user properly
    console.log(store)
    var auth = await ensureAuthIsInitialized(store)
    console.log(auth)
    console.log(isAuthenticated(store))
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      console.log('requiresAuth')
      console.log(to.meta)
      console.log(isAuthenticated(store))
      console.log("looka here")
      //console.log(store["user/currentUser"])
      let user = null
      if (isAuthenticated(store)){
        user = await getUserState()

      }
      console.log(isAuthenticated(store) && user)
      if (isAuthenticated(store) && user) {
        console.log(store.getters['user/currentUser'])
        var roleCheckResult = checkRole(
          to.meta.authorizedRoles,
          store.getters['user/currentUser'].role
        )
        if (roleCheckResult == false) {
          next('/notAuthorized')
        }
        next()
      } else {
        next('/login')
      }
    } else if (
      (to.path === '/auth/register' && isAuthenticated(store)) ||
      (to.path === '/auth/login' && isAuthenticated(store))
    )  {
      next('/')
    } else {
      next()
    }
  } catch (err) {
     console.log(err)
  }
})
// eslint-disable-next-line no-unused-vars
router.afterEach((to, _from) => {
  console.log(to.meta.title)
  Vue.nextTick(() => {
    document.title = to.meta.title
    //(to)
  })
})


/*router.beforeEach((to, from, next) => {
  const user = firebase.auth().currentUser;
 //console.log(store.state)
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
 //console.log(user)
  if (requiresAuth && !user) {
    next("/login");
  } else if (requiresAuth && user) {
    next();
  } else {
    next();
  }
});
/*

douter.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/register'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
})
*/
